import React from 'react';
import { GrLocation } from 'react-icons/gr';

const Location = (props) => {
  const { className } = props;
  return <GrLocation className={className} />;
};

export default Location;
